import { SettingBillSectionInformation } from '../components/SettingBillSection/interfaces';
import ContentToPrint from './ContentToPrint';
import ContentToShow from './ContentToShow';

interface ElectronicBillContentProps {
  order: any;
  setting: SettingBillSectionInformation;
  isLoading: boolean;
  isMultiBill?: boolean;
}

const ElectronicBillContent = ({
  order,
  setting,
  isLoading,
  isMultiBill = false,
}: ElectronicBillContentProps): JSX.Element => (
  <div className="bill-content">
    {!isMultiBill && (
      <ContentToShow isLoading={isLoading} order={order} setting={setting} />
    )}

    {isMultiBill && (
      <ContentToPrint isLoading={isLoading} order={order} setting={setting} />
    )}

    {!isLoading && !isMultiBill && (
      <div style={{ display: 'block', zIndex: -1, position: 'absolute' }}>
        <ContentToPrint isLoading={isLoading} order={order} setting={setting} />
      </div>
    )}
  </div>
);

export default ElectronicBillContent;
